import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  min-width: max-content;
  text-align: center;
`;
